import ModalCheckBoxGroup from "./ModalCheckBoxGroup";

export default ModalCheckBoxGroup;
